export const dataDefault = [{
    name: "Room Charge 房费",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Telephone Charge 电话费",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Business Centre 商务中心",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Laundry 洗衣",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Limousine 车费",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Tenant's Ledger 外租单位挂帐",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Misc.& Other 杂费及其它",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Food & Beverage 食品及酒水",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Mini Bar Charge 迷你吧",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Total",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "Rooms & F&B Revenue ",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}, {
    name: "-",
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    Total: 0,
}];


export const dataColumns = [
    {
        title: "Jan",
        name: "Jan",
        type: "inputNumber",
    }, {
        title: "Feb",
        name: "Feb",
        type: "inputNumber",
    }, {
        title: "Mar",
        name: "Mar",
        type: "inputNumber",
    }, {
        title: "Apr",
        name: "Apr",
        type: "inputNumber",
    }, {
        title: "May",
        name: "May",
        type: "inputNumber",
    }, {
        title: "Jun",
        name: "Jun",
        type: "inputNumber",
    }, {
        title: "Jul",
        name: "Jul",
        type: "inputNumber",
    }, {
        title: "Aug",
        name: "Aug",
        type: "inputNumber",
    }, {
        title: "Sep",
        name: "Sep",
        type: "inputNumber",
    }, {
        title: "Oct",
        name: "Oct",
        type: "inputNumber",
    }, {
        title: "Nov",
        name: "Nov",
        type: "inputNumber",
    }, {
        title: "Dec",
        name: "Dec",
        type: "inputNumber",
    }, {
        title: "Total",
        name: "Total",
        type: "number",
    }
];


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-9/data.js